import React, { memo, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
// import { NoMarginRow } from 'Components/EnhacedFlexboxGrid'

// import css from './styles.js'
import { _TabsContainer, _Tab, _Label, _Slider } from './styles'


export const Tab = ({ id, tab, label, isActive, onClick = () => {}, isPrint, layoutId }) => (
  <_Tab
    aria-label={label}
    isActive={isActive}
    hideRightBorder={id === 0}
    isPrint={isPrint}
    onClick={() => onClick(tab)}
    tabName={id}
  >
    {
      isActive && (
        <_Slider layoutId={layoutId || 'sliding'} />
      )
    }
    <_Label isActive={isActive}>{label}</_Label>
  </_Tab>
)

const useTabState = ({ defaultTab, handleClick }) => {
  const [currentTab, setTab] = useState(defaultTab)

  const setCurrentTab = tab => {
    setTab(tab)
    if(handleClick) handleClick(tab)
  }

  return { currentTab, setCurrentTab }
}

const OfferTabV3 = ({
  className,
  defaultTab = 'Sale',
  handleClick,
  isPrint,
  tabs = {
    Sale: 'Sold',
    Rent: 'Rented',
  },
  layoutId,
}) => {
  const { currentTab, setCurrentTab } = useTabState({
    defaultTab,
    handleClick,
  })
  useEffect(() => {
    setCurrentTab(defaultTab)
  }, [layoutId])
  return (
    <_TabsContainer className={className} >
      {Object.entries(tabs).map(([tab, tabName], index) => (
        <Tab
          key={tab + 'offerTab'}
          label={tabName}
          onClick={setCurrentTab}
          isActive={currentTab === tab}
          isPrint={isPrint}
          id={index}
          tab={tab}
          layoutId={layoutId}
        />
      ))}
    </_TabsContainer>
  )
}

Tab.propTypes = {
  id: PropTypes.number,
  label: PropTypes.string,
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
  isPrint: PropTypes.bool,
  tab: PropTypes.string,
  layoutId: PropTypes.string,
}
OfferTabV3.propTypes = {
  className: PropTypes.string,
  defaultTab: PropTypes.string,
  handleClick: PropTypes.func,
  isPrint: PropTypes.bool,
  tabs: PropTypes.shape({
    Sale: PropTypes.string,
    Rent: PropTypes.string,
  }),
  layoutId: PropTypes.string,
}
export default memo(OfferTabV3)
